/**
 * 404 Not Found Page
 *
 * Displayed when users navigate to non-existent routes.
 * Features refined styling with helpful navigation options.
 */

import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        {/* 404 Visual */}
        <div className="relative mb-8">
          <div className="text-[120px] font-black tracking-tighter text-guild-green/10 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-guild-mint/50 shadow-lg shadow-guild-green/10">
              <Search size={36} className="text-guild-green" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h1 className="text-2xl font-bold tracking-tight text-gray-900 mb-3">
          Page not found
        </h1>
        <p className="text-gray-500 mb-8 leading-relaxed">
          Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/dashboard"
            className="
              inline-flex items-center gap-2 w-full sm:w-auto
              rounded-xl bg-guild-green px-6 py-3
              text-sm font-semibold text-white
              shadow-lg shadow-guild-green/20
              hover:bg-guild-green/95 hover:shadow-xl hover:shadow-guild-green/25
              active:scale-[0.98]
              transition-all duration-200
            "
          >
            <Home size={18} />
            Go to Dashboard
          </Link>
          <button
            onClick={() => window.history.back()}
            className="
              inline-flex items-center gap-2 w-full sm:w-auto
              rounded-xl border-2 border-gray-200 bg-white px-6 py-3
              text-sm font-semibold text-gray-700
              hover:border-gray-300 hover:bg-gray-50
              active:scale-[0.98]
              transition-all duration-200
            "
          >
            <ArrowLeft size={18} />
            Go Back
          </button>
        </div>

        {/* Help text */}
        <p className="mt-8 text-xs text-gray-400">
          If you believe this is an error, please contact support.
        </p>
      </div>
    </div>
  );
}
